import { render, staticRenderFns } from "./leave-card.vue?vue&type=template&id=53300443&"
import script from "./leave-card.vue?vue&type=script&lang=js&"
export * from "./leave-card.vue?vue&type=script&lang=js&"
import style0 from "./leave-card.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports